module.exports = __webpack_public_path__ + "dist/images/01feb1db3dedce2bbdf828b137fa4ff7.gif";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/subscriptions/pupils.gif
// module id = 477
// module chunks = 0